import React from "react";
import CV from "../../assets/cv.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} download className="hvr btn">
        My CV
      </a>
      <a href="#contact" className=" btn">
        Let's Talk
      </a>
      <a href="https://osman245.github.io/blogz/" className="hvr btn">
        Blog
      </a>

    </div>
  );
};

export default CTA;
